import * as React from "react";
import styled from "styled-components";
import Paging from "react-bootstrap/Pagination";

interface Props {
  page: number;
  pageCount: number;
  setPage(page: number): void;
}

export function Pagination({ page, pageCount, setPage }: Props) {
  const pages = [];
  let min = Math.max(page - 3, 1);
  let max = Math.min(pageCount, min + 6);
  for (let i = min; i <= max; i++) {
    pages.push(
      <Paging.Item key={i} onClick={() => setPage(i)} active={i === page}>
        {i}
      </Paging.Item>,
    );
  }
  return (
    <Paging size="sm">
      <Paging.First disabled={page === 1} onClick={() => setPage(1)} />
      <Paging.Prev disabled={page === 1} onClick={() => setPage(page - 1)} />
      {pages}
      <Paging.Next disabled={page >= pageCount} onClick={() => setPage(page + 1)} />
      <Paging.Next disabled={page >= pageCount} onClick={() => setPage(page + 1)} />
      <Index>
        {page} of {pageCount}
      </Index>
    </Paging>
  );
}

const Index = styled.li`
  align-self: center;
  padding: 0 10px;
  opacity: 0.5;
`;
